import React, { FC } from "react";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const LinkedIn: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faLinkedinIn} {...props} />;
};
